var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":function($event){return _vm.handleEdit()}}}),_c('Table',{staticClass:"my-5",on:{"edit":_vm.handleEdit}}),_c('Form',{ref:"form"}),_c('BizServiceLoad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }